import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  clientSecret: null,
  sessionId: null,
  details: null,   // your donor/campaign data to show on success/failure page
};

const stripeCheckoutSlice = createSlice({
  name: 'stripeCheckout',
  initialState,
  reducers: {
    setStripeCheckout(state, action) {
      const { clientSecret = null, sessionId = null, details = null } = action.payload || {};
      state.clientSecret = clientSecret;
      state.sessionId = sessionId;
      state.details = details;
    },
    clearStripeCheckout(state) {
      state.clientSecret = null;
      state.sessionId = null;
      state.details = null;
    },
  },
});

export const { setStripeCheckout, clearStripeCheckout } = stripeCheckoutSlice.actions;
export default stripeCheckoutSlice.reducer;

